export default __webpack_public_path__ + "static/media/SEC2010.34I-41286_-24604_0.fc8a0265.jpg";